<script setup lang="ts">
import { ExclamationCircleIcon } from '@heroicons/vue/24/outline';
const { $t } = useNuxtApp();

const props = defineProps<{
  class?: string;
  tooltip?: string;
}>();
</script>

<template>
  <div
    v-bind="{
      ...(!!props.tooltip && { title: $t(props.tooltip) }),
      ...(!!props.class && { class: props.class }),
    }"
    class="cursor-help"
  >
    <ExclamationCircleIcon class="" />
  </div>
</template>

<style>
/* div[title]:hover::after {
  background-color: #fff !important;
} */
</style>
